"use client";
import { jsx as r } from "react/jsx-runtime";
import { withCmsDataHandling as y } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import { rem as H, Box as v, sharedHandler as u } from "@ingeniorforeningen/figurine-core";
import { forwardRef as x } from "react";
import { heroDeliveryApiParser as C } from "./Hero.helpers.js";
import k from "./variants/HeroEvent.js";
import D from "./variants/HeroSimple.js";
const i = x((t, n) => {
  const {
    variant: d = "simple",
    editLink: a,
    image: o,
    heading: s,
    description: m,
    occurences: p,
    leftCta: l,
    rightCta: h,
    active: c,
    inactiveDescription: f,
    ...g
  } = t, e = H("105px");
  return /* @__PURE__ */ r(v, { style: { "--passed-header-height": e }, ref: n, ...g, children: d === "event" ? /* @__PURE__ */ r(
    k,
    {
      occurences: p,
      leftCta: l,
      rightCta: h,
      active: c,
      inactiveDescription: f,
      editLink: a,
      image: o,
      heading: s,
      description: m,
      style: { "--passed-header-height": e }
    }
  ) : /* @__PURE__ */ r(
    D,
    {
      editLink: a,
      image: o,
      heading: s,
      description: m,
      link: t.link,
      style: { "--passed-header-height": e }
    }
  ) });
});
i.displayName = "Hero";
const N = y({
  Component: u(i),
  deliveryApiParser: C
});
N.displayName = i.displayName;
export {
  i as _Hero,
  N as default
};
